import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { DiscountConfigType } from "@/features/cart/types/discount.type";
import { getDiscountsConfig } from "@/features/discounts/api/get-dsocunts-config";

type UseGetDiscountInfoParams = {
  params?: RequestInit;
  id: string;
  options?: Omit<
    UseQueryOptions<
      DiscountConfigType,
      unknown,
      DiscountConfigType,
      string[]
    >,
    "queryFn" | "queryKey"
  >;
};

export const useGetDiscountConfig = ({
  params,
  options,
  id,
}: UseGetDiscountInfoParams) => {
  return useQuery({
    queryKey: ["discounts-config", id],
    queryFn: () => getDiscountsConfig({ params, id, client: true }),
    ...options,
  });
};
